import styled from 'styled-components'

import SceneryDetailedIcon from 'components/icons/SceneryDetailed'
import typeStyle from 'styles/typeStyle'

const Heading = styled.h5`
  ${typeStyle('-ds-font-lead')}
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  margin-bottom: 4px;
`

const Hint = styled.p`
  ${typeStyle('-ds-font-body-sm-light')}
  color: ${({ theme }) => theme?.['-ds-neutral-600']?.value};
`

const Outer = styled.div`
  position: absolute;

  display: flex;

  left: 16px;
  right: 16px;
  bottom: 86px;

  svg {
    flex-shrink: 0;
    width: 48px;
    height: 48px;

    margin-top: 5px;
    margin-right: 2px;
  }

  padding: 16px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};

  box-shadow:
    0px 0.25px 3px rgba(0, 0, 0, 0.039),
    0px 2.75px 9px rgba(0, 0, 0, 0.19);
`

const hintForSearchType = (searchType: GQL_ListingTypes) => {
  switch (searchType) {
    case 'adventures':
      return 'Try changing or removing your filters, or adjusting the search area.'
    case 'accommodation':
    default:
      return 'Try changing or removing your filters, adjusting the search area, or choosing different dates.'
  }
}

type Props = {
  searchType: GQL_ListingTypes
}

const NoResultsMessage = ({ searchType }: Props) => {
  const hint = hintForSearchType(searchType)

  return (
    <Outer>
      <div>
        <Heading>No Riparides found</Heading>
        <Hint>{hint}</Hint>
      </div>

      <SceneryDetailedIcon />
    </Outer>
  )
}

export default NoResultsMessage
